import { render, staticRenderFns } from "./BaseBModal.vue?vue&type=template&id=8134c4b8"
import script from "./BaseBModal.vue?vue&type=script&lang=js"
export * from "./BaseBModal.vue?vue&type=script&lang=js"
import style0 from "./BaseBModal.vue?vue&type=style&index=0&id=8134c4b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports